// Subject → Domain mapping (compulsory selection in registration)
// Source: user-provided list of subjects with domain options

export const SUBJECTS = [
  {
    id: "physics",
    name: "Physics",
    domains: [
      "Teaching and Academic Assistance",
      "Renewable Energy and Sustainability",
      "Data Analysis & AI",
      "Engineering & Construction",
    ],
  },
  {
    id: "chemistry",
    name: "Chemistry",
    domains: [
      "Laboratory Research and Analysis",
      "Pharmaceutical and Drug Development",
      "Quality Control and Quality Assurance",
      "Environmental Chemistry",
      "Food and Cosmetic Chemistry",
      "Teaching and Academic Assistance",
    ],
  },
  {
    id: "mathematics",
    name: "Mathematics",
    domains: [
      "Data Analysis and Statistics",
      "Teaching and Academic Assistance",
      "Banking Finance and Quantitative Analysis",
      "Operations Research and Optimization",
      "CS & IT",
      "Data Science and Machine Learning (Basic Level) using AI",
    ],
  },
  {
    id: "zoology",
    name: "Zoology",
    domains: [
      "Conservation and Management",
      "Veterinary Science and Animal Care",
      "Environmental and Ecology Structure",
      "Teaching and Academic Assistance",
      "NGO and Animal Welfare Organizations",
    ],
  },
  {
    id: "botany",
    name: "Botany",
    domains: [
      "Agriculture and Horticulture",
      "Environmental and Ecology Studies",
      "Forestry and Conservation",
      "Herbal and Medicinal Plants",
      "Teaching and Academic Assistance",
      "Floriculture and Landscape Design",
    ],
  },
  {
    id: "accounting-finance",
    name: "Accounting and Finance",
    domains: [
      "Accounting and Bookkeeping",
      "Taxation (Direct and Indirect)",
      "Auditing and Assurance",
      "Banking and Financial Services",
      "Financial Analysis and Investment",
      "Corporate Finance",
      "Payroll and Compliance",
      "FinTech and Digital Finance",
    ],
  },
  {
    id: "marketing",
    name: "Marketing",
    domains: [
      "Digital Marketing",
      "Social Media Marketing",
      "Sales and Business Development",
      "Market Research and Analysis",
      "Content Marketing and Copywriting",
      "Branding and Advertising",
      "Email and Performance Marketing",
      "Event Marketing and Promotions",
    ],
  },
  {
    id: "hr-management",
    name: "Human Resource Management",
    domains: [
      "Recruitment and Talent Acquisition",
      "Training and Development",
      "Payroll and Compensation Management",
      "Employee Engagement and Relations",
      "HR Operations and Administration",
      "Performance Management System",
      "Compliance and Labour Laws",
      "HR Analytics and HR Tech",
    ],
  },
  {
    id: "economics",
    name: "Economics / Rural Economics",
    domains: [
      "Economic Research and Data Analysis",
      "Rural Development and Field Work",
      "Banking and Financial Inclusion",
      "Policy Analysis and Public Finance",
      "NGO and Development Sector",
      "Agriculture Economics",
      "Livelihood and Skill Development Programs",
      "Market Research and Economic Consulting",
    ],
  },
  {
    id: "psychology",
    name: "Psychology",
    domains: [
      "Pharmacy Internship",
      "Child and School Psychology",
      "Research and Data Collection",
      "NGO and Community Mental Health Work",
      "HR and Organizational Psychology",
      "Rehabilitation and Special Needs Support",
    ],
  },
  {
    id: "political-science",
    name: "Political Science",
    domains: [
      "NGO and Development Sector",
      "Political Research and Analysis",
      "Advocacy and Public Affairs",
      "Journalism and Political Reporting",
      "Legal and Constitutional Studies",
      "Social Media and Political Campaign Management",
    ],
  },
  {
    id: "public-administration-pa",
    name: "Public Administration (P.A)",
    domains: [
      "Policy Research and Public Administration",
      "Public Policy and Governance",
      "Administrative Services and Office Management",
      "NGO and Development Sector",
      "Civic Engagement and Public Affairs",
    ],
  },
  {
    id: "history-aih",
    name: "History / AIH",
    domains: [
      "Research and Documentation",
      "Content Writing and Historical Blogging",
      "Education and Teaching Assistance",
      "Cultural Research and Preservation",
      "Tourism and Heritage Guide Services",
    ],
  },
  {
    id: "geography",
    name: "Geography",
    domains: [
      "GIS and Mapping",
      "Survey and Field Work",
      "Environmental Studies and Sustainability",
      "Urban and Regional Planning",
      "Disaster Management",
      "Tourism and Travel Planning",
      "Agriculture and Rural Development",
    ],
  },
  {
    id: "home-science",
    name: "Home Science",
    domains: [
      "Nutrition and Dietetics",
      "Food Science and Food Processing",
      "Human Development and Child Care",
      "Textile and Fashion Designing",
      "Interior Design and Home Management",
    ],
  },
  {
    id: "sociology",
    name: "Sociology",
    domains: [
      "Social Research and Data Analysis",
      "NGO and Community Development",
      "Rural and Urban Development",
      "Social Work and Welfare Programs",
      "Policy Research and Public Administration",
      "Human Rights and Advocacy",
      "Education and Teaching Assistance",
      "Media Communication and Social Content",
    ],
  },
  {
    id: "philosophy",
    name: "Philosophy",
    domains: [
      "Research and Academic Writing",
      "Teaching and Academic Assistance",
      "Ethics and Policy Analysis",
      "Content Writing and Blogging",
      "Counseling and Human Values Education",
      "NGO and Social Work",
      "Publishing and Editorial Work",
    ],
  },
  {
    id: "english",
    name: "English",
    domains: [
      "Content Writing, Editing and Publishing, Journalism and Media",
      "Education and Teaching Assistance",
      "Advocacy",
      "Political Research",
      "Marketing",
    ],
  },
  {
    id: "hindi",
    name: "Hindi",
    domains: [
      "Content Writing, Editing and Publishing, Journalism and Media",
      "Education and Teaching Assistance",
      "Advocacy",
      "Political Research",
      "Marketing",
    ],
  },
  {
    id: "pali",
    name: "Pali",
    domains: [
      "Content Writing, Editing and Publishing, Journalism and Media",
      "Education and Teaching Assistance",
      "Advocacy",
      "Political Research",
      "Marketing",
    ],
  },
  {
    id: "urdu-persian",
    name: "Urdu / Persian",
    domains: [
      "Content Writing, Editing and Publishing, Journalism and Media",
      "Education and Teaching Assistance",
      "Advocacy",
      "Political Research",
      "Marketing",
    ],
  },
  {
    id: "sanskrit",
    name: "Sanskrit",
    domains: [
      "Content Writing, Editing and Publishing, Journalism and Media",
      "Education and Teaching Assistance",
      "Advocacy",
      "Political Research",
      "Marketing",
    ],
  },
  {
    id: "maithili",
    name: "Maithili",
    domains: [
      "Content Writing, Editing and Publishing, Journalism and Media",
      "Education and Teaching Assistance",
      "Advocacy",
      "Political Research",
      "Marketing",
    ],
  },
  {
    id: "bangla",
    name: "Bangla",
    domains: [
      "Content Writing, Editing and Publishing, Journalism and Media",
      "Education and Teaching Assistance",
      "Advocacy",
      "Political Research",
      "Marketing",
    ],
  },
  {
    id: "music",
    name: "Music",
    domains: [
      "Music Production and Sound Engineering",
      "Performance and Live Events",
      "Teaching and Music Education",
      "Composition and Songwriting",
      "Digital Content Creation (Music)",
      "Music Marketing and Promotion",
      "Radio Podcast and Voice Work",
      "Music Therapy (Basic Level)",
    ],
  },
];

// Helper: get domains list for a given subject id
export const getDomains = (subjectId) => {
  const s = SUBJECTS.find((x) => x.id === subjectId);
  return s ? s.domains : [];
};
